module.exports = __webpack_public_path__ + "img/111.9dc0754a.jpg";